import { Button, styled, Theme } from '@material-ui/core';

export const MainCont = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 25,
});

export const Content = styled('div')({
  margin: '20px 0',
});

export const SaveButton = styled(Button)({
  maxWidth: 320,
  height: 50,
  borderRadius: 8,
});

export const FlexContainer = styled('div')<Theme, { gap?: number }>(({ gap = 0 }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: gap,
}));

export const ResetButton = styled(Button)({
  height: 30,
  background: '#18212E',
  borderRadius: 8,
  padding: '0 10px',
});
